import Cabinet from "../containers/cabinet/Cabinet";
import CabinetCover from "../containers/cabinet/CabinetCover";
import CabinetInfo from "../containers/cabinet/CabinetInfo";

const routes = [
  {
    component: Cabinet,
    routes: [
      {
        path: "/",
        exact: true,
        component: CabinetCover
      },
      {
        path: "/:pageName",
        exact: true,
        component: CabinetInfo
      }
    ]
  }
];

export default routes;



// WEBPACK FOOTER //
// ./application/frontend/src/routing/routes.js